import { render, staticRenderFns } from "./OurWorkComponent4.vue?vue&type=template&id=3a865440&scoped=true&"
import script from "./OurWorkComponent4.vue?vue&type=script&lang=js&"
export * from "./OurWorkComponent4.vue?vue&type=script&lang=js&"
import style0 from "./OurWorkComponent4.vue?vue&type=style&index=0&id=3a865440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a865440",
  null
  
)

export default component.exports